/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ actor: NonNullable<unknown>, date: NonNullable<unknown> }} Orders_Tracking_Audit_By_AtInputs */

const en_orders_tracking_audit_by_at = /** @type {(inputs: Orders_Tracking_Audit_By_AtInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Set by ${i?.actor} · ${i?.date}`)
};

const es_orders_tracking_audit_by_at = /** @type {(inputs: Orders_Tracking_Audit_By_AtInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Establecido por ${i?.actor} · ${i?.date}`)
};

/**
* | output |
* | --- |
* | "Set by {actor} · {date}" |
*
* @param {Orders_Tracking_Audit_By_AtInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const orders_tracking_audit_by_at = /** @type {((inputs: Orders_Tracking_Audit_By_AtInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Orders_Tracking_Audit_By_AtInputs, { locale?: "en" | "es" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_orders_tracking_audit_by_at(inputs)
	return es_orders_tracking_audit_by_at(inputs)
});